import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {Row, Col, Card, CardBody, Collapse} from 'reactstrap';

//import  styledMagstimTableWrapper from 'common/controls/StyledMagstimTableWrapper'
import { MagstimAccordionHeader, MagstimTableTreatmentTemplate, MagstimTableCombinedTreatmentTemplate, MagstimColor, styles, MagstimFetch, isPDA, CurrentLang } from "common";

import { REST_ENDPOINT_TREATMENT_TEMPLATES } from 'common/ApiEndpoints';

class ViewTreatmentTemplates extends React.Component {

	constructor(props) {
		super(props);

		// console.log(this.getInitialState())

		this.state = {
			//isAccordionOpen: [false, false]
			isAccordionOpen: this.getInitialState(),
			mainTableClassName: isPDA() ? "ui-bg ui-scroll pl-0 pr-0" : "ui-bg ui-scroll",
			combinedTableData:[]
		};

		this._tableCombined = React.createRef();
		this._tableIndividual = React.createRef();

		window._initViewTreatmentTemplates = this.initForEdit.bind(this);
	}

	getInitialState = () => {
		/* eslint-disable no-undef */
		// eslint-disable-next-line no-unused-vars
		var isAccordionOpen = localStorage.getItem('isAccordionOpen') || [false, false];

		// console.log("getInitialState1", isAccordionOpen);

		if (typeof isAccordionOpen === 'string' || isAccordionOpen instanceof String) {
			isAccordionOpen = isAccordionOpen.split(',');
			isAccordionOpen = [isAccordionOpen[0] === "true", isAccordionOpen[1] === "true"]
		}

		// console.log("getInitialState2", isAccordionOpen);

		return isAccordionOpen
	}

	storeLocalState = (openState) => {
		// console.log("storeLocalState", openState)

		localStorage.setItem('isAccordionOpen', openState);
		this.setState({ isAccordionOpen: openState });
	}

	initForEdit = (combinedTableData, individualTableData, isReloading) => {
		// console.log('initForEdit combinedTableData = ' + JSON.stringify(combinedTableData, null, 2));
		// console.log('initForEdit individualTableData = ' + JSON.stringify(individualTableData, null, 2));
		combinedTableData.isGrouped = true;

		if(this._tableCombined && this._tableCombined.current){
			this._tableCombined.current.initForEdit(combinedTableData);
		}

		if(this._tableIndividual && this._tableIndividual.current){
			this._tableIndividual.current.initForEdit(individualTableData);
		}
	}

	initForSelect = (combinedTableData, individualTableData, isReloading) => {
		// console.log('initForSelect combinedTableData = ' + JSON.stringify(combinedTableData, null, 2));
		// console.log('initForSelect individualTableData = ' + JSON.stringify(individualTableData, null, 2));	
		combinedTableData.isGrouped = true;

		if(this._tableCombined && this._tableCombined.current){
			this._tableCombined.current.initForSelect(combinedTableData);
		}

		if(this._tableIndividual && this._tableIndividual.current){
			this._tableIndividual.current.initForSelect(individualTableData);
		}
	}

	toggleOnClick0 = (eventKey) => {
		this.toggleOnClick(0, eventKey);
	}
	toggleOnClick1 = (eventKey) => {
		this.toggleOnClick(1, eventKey);
	}

	toggleOnClick = (index) => {
		var isOpen = this.state.isAccordionOpen;
		isOpen[index] = !isOpen[index];
		this.storeLocalState(isOpen)
	}

	selectionChangedCallback = (event, isSelected, rows, row) => {
		if (this.props.selectionChangedCallback) {
			this.props.selectionChangedCallback(event, isSelected, rows, row);
		}
	}

	magstim_eventHandler_callback = (eventName, value, additionalData) => {
		if(this.props.magstim_eventHandler_callback){
			this.props.magstim_eventHandler_callback(eventName, value, additionalData);
		}
	}

	combinedTreatmentCellClickCallback = (row, column, cell) => {
		if (this.props.combinedTreatmentCellClickCallback) {
			this.props.combinedTreatmentCellClickCallback(row, column, cell);
		}
	}

	individualTreatmentCellClickCallback = (row, column, cell) => {
		if (this.props.individualTreatmentCellClickCallback) {
			this.props.individualTreatmentCellClickCallback(row, column, cell);
		}
	}

	render() {

		//let setExpanded0 = null;
		//let setExpanded1 = null;
		//if (this.state.isAccordionOpen[0]) { setExpanded0 = 0; }
		//if (this.state.isAccordionOpen[1]) { setExpanded1 = 1; }

		// console.log("setExpanded0", setExpanded0, "setExpanded1", setExpanded1)
		// console.log(`render this.state=${JSON.stringify(this.state)}`);
		return (
			<Wrapper>
				<Row className="ui-fillh pt-4">
					<Col className={this.state.mainTableClassName}>
					
							<Card className="accordion-card">
								<MagstimAccordionHeader
									isOpen={this.state.isAccordionOpen[0]}
									add_id='idNewCombined'
									main_title={CurrentLang().view_treatment_template_combined_title}
									main_icon="fa fa-cubes"
									eventKey={0}
									magstim_eventHandler_callback={this.magstim_eventHandler_callback}
									toggleOnClick={this.toggleOnClick0}
								/>

								<Collapse  isOpen={this.state.isAccordionOpen[0]} >
									<CardBody style={styles.cardBody}>
										<MagstimTableCombinedTreatmentTemplate
											ref={this._tableCombined}
											div_name="CombinedTreatmentTemplates"
											cellClickCallback={this.combinedTreatmentCellClickCallback}
											selectionChangedCallback={this.selectionChangedCallback}
										/>
									</CardBody>
								</Collapse>
							</Card>
	
							<Card className="pt-4 accordion-card" >
								<MagstimAccordionHeader
									isOpen={this.state.isAccordionOpen[1]}
									add_id='idNewIndividual'
									main_title={CurrentLang().view_treatment_template_individual_title}
									main_icon="fa fa-cube"
									eventKey={1}
									magstim_eventHandler_callback={this.magstim_eventHandler_callback}
									toggleOnClick={this.toggleOnClick1} />

								<Collapse  isOpen={this.state.isAccordionOpen[1]}>
									<CardBody style={styles.cardBody}>
										<MagstimTableTreatmentTemplate
											ref={this._tableIndividual}
											div_name="IndividualTreatmentTemplates"
											cellClickCallback={this.individualTreatmentCellClickCallback}
											selectionChangedCallback={this.selectionChangedCallback}
										/>
									</CardBody>
								</Collapse>
							</Card>
						
					</Col>
				</Row>
			</Wrapper>
		);
	}

	componentDidMount() {
		if ((undefined !== this.props.initParams) && (undefined === this.isInitialised)) {
			console.log(`ViewTreatmentTemplates.componentDidMount props=${JSON.stringify(this.props, null, 4)} state=${JSON.stringify(this.state, null, 4)} `);
			this.initForEdit(this.props.initParams.combinedTableData, this.props.initParams.individualTableData, this.props.initParams.isReloading);
			this.isInitialised = true;
		}
		else if (process.env.NODE_ENV !== "production") {
			if(!isPDA()){
				this.loadDebugData();
			}
		}

		if(isPDA()){
			this.loadDataFromAPI();
		}
	}

	loadDataFromAPI(){
		MagstimFetch.get(REST_ENDPOINT_TREATMENT_TEMPLATES)
		.then((data) => {

			if ((undefined !== data.individualTableData) && (null !== data.individualTableData)) {
				for (var x = 0; x < data.individualTableData.length; x++) {
					const pt = data.individualTableData[x];
					if ((undefined !== pt.ResourceId) && (null !== pt.ResourceId)) {
						const localised = CurrentLang()[pt.ResourceId];
						if ((undefined !== localised) && (null !== localised)) {
							console.log(`Translating ${pt.ResourceId} resourceID to "${localised}"`);
							pt.name = localised;
						}
					}
				}
			}

			this.setState({combinedTableData:data.combinedTableData});

			if(this.props.isEdit){
				this.initForEdit(data.combinedTableData, data.individualTableData);
			}else{
				this.initForSelect(data.combinedTableData, data.individualTableData);
			}
		})
		.catch((error) => {
			this.props.handleError(error);
		});
	}

	loadDebugData() {

		var individualTableData = [
			{ name: 'FDA', pcRMT: 110, pps: 10, duration: 1234.0, pulses: 4000, waitTime: 2.0, trains: 1, mode: 'Standard', isSystemProtocol: true },
			{ name: 'FDA 19', pcRMT: 90, pps: 10, duration: 1.123456789, pulses: 4000, waitTime: 2.0, trains: 1, mode: 'Burst', isSystemProtocol: true },
			{ name: 'Standard A', pcRMT: 110, pps: 10, duration: 1234.0, pulses: 4000, waitTime: 2.0, trains: 1, mode: 'Standard' },
			{ name: 'Standard B', pcRMT: 90, pps: 10, duration: 1.123456789, pulses: 4000, waitTime: 2.0, trains: 1, mode: 'Burst' },
			{ name: 'Anxiety', pcRMT: 90, pps: 10, duration: 82.0, pulses: 4000, waitTime: 2.0, trains: 1, mode: 'Burst' },
		];

		var combinedTableData = [
			{ groupName: 'Combined treatment A', data: [individualTableData[0], individualTableData[1]] },
			{ groupName: 'Combined treatment B', data: [individualTableData[1], individualTableData[2]] },
			{ groupName: 'Combined treatment D', data: [individualTableData[0], individualTableData[1], individualTableData[2]] }
		];

		this.initForEdit(combinedTableData, individualTableData)
	}

	getTreatmentTemplateGuid(groupName){

		var treatmentTemplateGuid = "";

		this.state.combinedTableData.forEach(function (item, index) {
			if(item.groupName === groupName){
				treatmentTemplateGuid = item.TreatmentTemplateGuid;
			}
		});

		return treatmentTemplateGuid;
	}
}


ViewTreatmentTemplates.propTypes = {
	selectionChangedCallback: PropTypes.func
};

ViewTreatmentTemplates.defaultProps = {
	selectionChangedCallback: undefined
};

const Wrapper = styled.main`
	.ui-scroll {
		height: calc(100vh - 1.5rem);
	}

	#CombinedTreatmentTemplates,
	#IndividualTreatmentTemplates {
		margin: 0px;
	}

	.table-wrapper {
		.table-scroll {
			overflow: auto;
			margin-top: 60px;

			table thead tr th span {
				display: block;
				padding: 0 10px;
				top: -50px;
				vertical-align: middle;

				div {
					padding-left: 10px;
				}
			}
			table thead tr th:first-child span {
				height: 50px;
				top: -60px;
				background-color: ${ MagstimColor.MagstimSecondaryButton};

				div {
					padding-top: 10px;
					padding-left: 10px;
				}
			}
			table thead tr th span div {
				display: block;
				height: 30px;
				line-height: 30px;
				vertical-align: middle;
			}

			table tbody {
				
				tr.group-header {
					padding-left: 10px;
					padding-right: 10px;
					height: 60px;
					background: ${ MagstimColor.MagstimPrimaryBlue};
					border-bottom: 2px solid ${ MagstimColor.MagstimSecondaryButton};
				}
				.group-header td {
					padding-left: 20px;
					padding-right: 10px;
				}
				td {
					padding-left: 20px;
					padding-right: 10px;
					border-bottom: 1px solid ${ MagstimColor.MagstimSecondaryButton};
				}

			}
		}
	}

	#IndividualTreatmentTemplates {
		table tbody tr {
			margin-right: 3px;
			background: ${ MagstimColor.MagstimPrimaryBlue};
			border-bottom: 2px solid ${ MagstimColor.MagstimGroupBackground};
			height: 60px;
		}
		table tbody .dummy-row {
			background: transparent;
			height: 1px;
			border-top-width: 0px;
			border-bottom-width: 0px;
			padding-top-width: 0px;
			padding-bottom-width: 0px;
		}
	}

.accordion-card.card  {
	border-width: 0px;
	border-radius: 0.25em;
	background: transparent;
}

.navbar {
	height: 100%;
}

.btn-group {
	margin-top: 10px;
	margin-bottom: 10px;
	min-width: 250px;

	button {
		border: none;
		border-radius: .3rem !important;
	}

	button:nth-of-type(2) {
		margin-left: 12px;
	}
}

`;

export default ViewTreatmentTemplates